import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface AccordionItemProps {
  title: string;
  content: string | React.ReactNode;
  isOpen: boolean;
  onToggle: () => void;
}
function AccordionItem({
  title,
  content,
  isOpen,
  onToggle
}: AccordionItemProps) {
  return <div className="border-b border-light-grey" data-id="element-97">
      <button className="w-full flex justify-between items-center py-5 px-6 text-left hover:bg-light-grey/30 transition-colors" onClick={onToggle} aria-expanded={isOpen} data-id="element-98">
        <span className="text-lg font-semibold text-navy pr-4" data-id="element-99">{title}</span>
        <ChevronDownIcon className={`h-5 w-5 text-navy flex-shrink-0 transition-transform ${isOpen ? 'transform rotate-180' : ''}`} data-id="element-100" />
      </button>
      {isOpen && <div className="px-6 pb-5" data-id="element-101">
          <div className="text-dark" data-id="element-102">{content}</div>
        </div>}
    </div>;
}
interface AccordionProps {
  items: Array<{
    title: string;
    content: string | React.ReactNode;
  }>;
}
export default function Accordion({
  items
}: AccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const handleToggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <div className="bg-white rounded-lg shadow-sm overflow-hidden" data-id="element-103">
      {items.map((item, index) => <AccordionItem key={index} title={item.title} content={item.content} isOpen={openIndex === index} onToggle={() => handleToggle(index)} data-id="element-104" />)}
    </div>;
}